import packageJson from './../../package.json';

const PageHome = () => <>
    <header className="container my-5">
        &nbsp;
    </header>
    <main className="container my-5 text-center">
        <h1>Welcome to SVI Reviews</h1>
    </main>
    <footer className="container my-5">
        <div className="row text-center">
            <small className="text-muted">©{new Date().getFullYear()} StorageVault Canada - v{packageJson.version}</small>
        </div>
    </footer>
</>

export default PageHome;